<template>
  <div class="device-detail">
    <device-map-pivot
      :device="deviceMap"
      :deviceId="device"
    />

    <v-tabs centered color="transparent" light fixed-tabs
      v-model="currentTab"
    >
      <v-tabs-slider color="#0099E1"></v-tabs-slider>
      <v-tab 
        v-for="tab in tabs"
        :href="'#tab-' + tab.name"
        :key="tab.name"
        :id="tab.name"
      >
        {{tab.name}}
      </v-tab>

      <v-tabs-items touchless v-model="currentTab">
        <v-tab-item
          v-for="tab in tabs"
          :value="'tab-' + tab.name"
          :key="tab.name"
        >
          <component :is="tab.component" :id="id" :device="device" ref="childComponent" ></component>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <device-actions v-if="device.Organization.id!=this.$ponceConfig.organizationDemoId" :device="device" :deviceId="id" @reload-device="updateDevice"/>
  </div>
</template>

<script>
  import CurrentCycle from './CurrentCycle.vue';
  import Timeline from './Timeline.vue';
  import DeviceMapPivot from './DeviceMapPivot.vue';
  import DeviceActions from './DeviceActions.vue';

  import { DEVICE_DETAIL_QUERY } from '../../../constants/graphql';
  
  export default {
    name: 'deviceDetail',
    props: ['id'],
    data () {
      return {
        currentTab: 'tab-Ciclo actual',
        tabs: [
          {
            name: 'Ciclo actual',
            component: CurrentCycle
          },
          {
            name: 'Eventos',
            component: Timeline
          }
        ],

        Timeline: Timeline
      };
    },
    apollo: {
      Device: {
        query: DEVICE_DETAIL_QUERY,
        variables () {
          return {
            id: this.id
          };
        }
      }
    },
    computed: {
      deviceMap () {
        if (this.Device && this.Device.Event) {
          this.Device.Event.label = 'right';
          this.Device.Event['border-color'] = this.$ponceConfig.checkStatus(this.Device.Event.State.value);
        }
        let deviceAux = Object.assign({
          zoom: 15,
          State: {},
          Event: {
            State: {}
          },
          Crops: [{}]
        }, this.Device);

        deviceAux.prevEvent = deviceAux.Event;
        return deviceAux;
      },
      device () {
        return Object.assign({
          pump: {
          },
          state: {
            current: {
              firstSnapshot: {
                createdAt: new Date()
              }
            },
            previous: {
              value: 0
            }
          },
          Organization: {},
          zoom: 15,
          equipment: {
            length: 420,
            center: {
              location: {
                latitude: -37.902028,
                longitude: -58.367083
              }
            }
          }
        }, this.Device);
      },
      current () {
        let direction;
        let current = this.device.state.current;

        if (!current || !current.lastSnapshot || !current.lastSnapshot.revolution || !current.lastSnapshot.position) {
          return {};
        }

        if (current.lastSnapshot.revolution.direction === 'F') {
          direction = 'right';
        } else {
          direction = 'left';
        }
        return {
          'angle': current.lastSnapshot.position.angle,
          'border-color': this.$ponceConfig.checkStatus(current.value),
          'label': direction,
          'state': current.value
        };
      },
      previous () {
        let current = this.device.state.current;

        if (!current || !current.previousLastSnapshot || !current.previousLastSnapshot.revolution || !current.previousLastSnapshot.position ||
            !current.previousFirstSnapshot || !current.previousFirstSnapshot.position || current.previousValue) {
          return {};
        }

        let direction;
        if (current.previousLastSnapshot.revolution.direction === 'F') {
          direction = 'right';
        } else {
          direction = 'left';
        };
        return {
          'startAngle': current.previousFirstSnapshot.position.angle,
          'angle': current.previousLastSnapshot.position.angle,
          'border-color': this.$ponceConfig.checkStatus(current.previousValue),
          'label': direction,
          'state': current.previousValue
        };
      }
    },
    methods: {
      updateDevice () {
        this.$apollo.queries.Device.refetch();
      },
      Timestamp (date) {
        this.toDate = () => {
          return date;
        };
        this.toMillis = () => {
          return date.getTime();
        };
      }
    },
    components: {
      'device-map-pivot': DeviceMapPivot,
      'device-actions': DeviceActions
    },
    watch: {
      currentTab (value) {
        if (value === 'tab-Eventos') {
          mixpanel.track('Click device detail tab-eventos');
          gtag('event', 'tab_eventos', {event_category: 'click', event_label: 'Click device detail tab-eventos'});
        } else {
          mixpanel.track('Click device detail tab-ciclo actual');
          gtag('event', 'tab_ciclo_actual', {event_category: 'click', event_label: 'Click device detail tab-ciclo actual'});
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// DeviceDetail.vue?584c0650